/* eslint-disable quotes */
export const mockedTags = {
  '@odata.context': 'http://c1-si-odataapi.trafficmanager.net:8080/Advertiser/v2/$metadata#Tags',
  '@odata.count': 12,
  value: [
    {
      Id: 6302851,
      Name: 'xytestTag1',
      TrackingCode: '',
      IsPreferredTag: false,
      Owner: {
        Id: 257194955, Name: "xytest", Number: "F10400ZC4Z", Account: null,
      },
    },
    {
      Id: 1103231,
      Name: 'preferredTag',
      TrackingCode: '',
      IsPreferredTag: true,
      Owner: {
        Id: 257194955, Name: "xytest", Number: "F10400ZC4Z", Account: null,
      },
    },
    {
      Id: 104000491,
      Name: 'xytesttag111122',
      TrackingCode: '',
      IsPreferredTag: false,
      Owner: {
        Id: 257194955, Name: "xytest", Number: "F10400ZC4Z", Account: null,
      },
    },
  ],
};
